<template>
  <div class="contain">
    <div class="layout-atten">
      <p class="name-clock-atten">{{salesName}}</p>
      <p class="info-clock-atten"><span class="color-gray">当前位置：</span>{{signCheckLocation.address}}<span v-show="signCheckLocation.address==''">{{locatingStr}}</span></p>
      <p class="info-clock-atten"><span class="color-gray">经度：</span>{{signCheckLocation.lng}}</p>
      <p class="info-clock-atten"><span class="color-gray">纬度：</span>{{signCheckLocation.lat}}</p>
    </div>
    <div class="btn-clock"
         @click="checkin"><span class="tit-clock">打卡</span><span class="time-clock">{{nowDate}}</span></div>
    <p class="rep-clock"
       @click="reLoaction">定位不准？重新定位</p>
  </div>
</template>

<script>
import checkinModel from '../../../api/model/checkin'
import { mapState } from 'vuex'
export default {
  name: 'SignCheckin',
  data() {
    return {
      nowDate: '',
      address: '',
      dotNum: 0,
      locatingStr:'定位中请稍后'
    }
  },
  methods: {
    currentTime() {
      setInterval(this.formatDate, 500)
      setInterval(this.locating, 1000)
    },
    formatDate() {
      let date = new Date()
      let hour = date.getHours() // 时
      hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
      let minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零
      let second = date.getSeconds() // 秒
      second = second < 10 ? '0' + second : second // 如果只有一位，则前面补零
      this.nowDate = `${hour}:${minute}:${second}`
    },
    reLoaction() {
      this.$bus.$emit('callReloacation', null)
    },
    locating(){
      this.locatingStr+='.'
      this.dotNum++
      if(this.dotNum>6){
        this.locatingStr='定位中请稍后'
        this.dotNum=0
      }
    },
    async checkin() {
      if(this.signCheckLocation.lng=='0.00'||this.signCheckLocation.lat=='0.00'){
        this.$toast('请等待定位完成后再进行打卡')
        return false
      }
      const res=await checkinModel.addSignCheckrecords(this.signCheckLocation,null)
      if(res.success){
        this.$toast('打卡成功')
      }else{
        this.$toast(res.msg)
      }
    },
  },
  computed: {
    ...mapState('loacationAbout', ['signCheckLocation']),
    ...mapState('userAbout', ['salesName']),
  },
  mounted() {
    this.currentTime()
  },
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate) //清除时间定时器
    }
    if (this.locating) {
      clearInterval(this.formatDate) //清除时间定时器
    }
  },
}
</script>

<style scoped>
</style>